import { Step } from "react-joyride";

export const tourStepsMissingNumber = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Missing Number shows a sequence with one blank. Type the number that belongs in the blank.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Choose counting by 1s, skip counting, mixed, or create your own sequences. Custom sets can be saved.",
    },
    {
      target: "#patternMode",
      content:
        "If you choose Create your own, type numbers like 1, 2, 3, 4, then click the number that should be the blank.",
    },
    {
      target: ".start-button",
      content:
        "Start the game, type the missing number, and press Enter or Check. A new sequence appears after a correct answer.",
    },
  ];

  return steps;
};
